import React from 'react';
import type { GroupBase, OptionProps } from 'react-select';
import { components } from 'react-select';

import { FormikValues } from 'formik';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

//models
import { FilterAllOption } from '../../../models/sample.model';

// components
import { SearchableSelectType } from '../../inputs/searchableSelect';

interface FilterOptionProps {
    setFieldValue: (
        field: string,
        value: any,
        shouldValidate?: boolean,
    ) => void;
    columnId: string;
    values?: FormikValues;
}
const FilterOption: React.FC<
    React.PropsWithChildren<
        OptionProps<
            SearchableSelectType,
            boolean,
            GroupBase<SearchableSelectType>
        > &
            FilterOptionProps
    >
> = (props) => {
    const existingValues = props?.values?.[props.columnId];
    const checked = !!existingValues?.includes(props.data.value);

    return (
        <components.Option {...props}>
            <OptionDiv
                data-testid={`${props.columnId}-${props.data.label}-option`}
                onClick={(e) => {
                    e.stopPropagation();
                    if (checked) {
                        if (existingValues.length === 1) {
                            props.setFieldValue(props.columnId, [
                                FilterAllOption.All,
                            ]);
                        }
                        props.setFieldValue(
                            props.columnId,
                            existingValues.filter(
                                (item: string) => item !== props.data.value,
                            ),
                        );
                    } else {
                        props.setFieldValue(props.columnId, [
                            ...(existingValues || []),
                            props.data.value,
                        ]);
                    }
                }}
            >
                {' '}
                <CheckboxLabel>
                    <Checkbox
                        data-name={`${props.columnId}-${props.data.label}-option-checkbox`}
                        type="checkbox"
                        defaultChecked={checked}
                    />
                    <span>{props.data.label}</span>
                </CheckboxLabel>
                <span>{props.data?.info}</span>
            </OptionDiv>
        </components.Option>
    );
};

export default FilterOption;

const OptionDiv = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    gap: aampeTheme.spacing4(3),
    color: aampeTheme.colors.gray800,
    fontSize: aampeTheme.spacing(2),
    fontWeight: 400,
    lineHeight: aampeTheme.spacing(2),
});

const Checkbox = styled.input({
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
    '&:checked': {
        accentColor: aampeTheme.colors.solidA01,
    },
});

const CheckboxLabel = styled.span({
    display: 'flex',
    gap: aampeTheme.spacing(1),
    alignItems: 'start',
    wordBreak: 'break-word',
});
